<template>
    <el-container class="sub-page" :class="{'fullPage': fullPage, 'plain': plain}">
        <el-main>
            <el-card class="box-card">
                <template #header>
                    <slot v-if="$slots.header" name="header"></slot>

                    <div v-else-if="title" class="sub-page-header" :style="{textAlign: titleAlign}">
                        <slot name="prefix"></slot>
                        <span>{{title}}</span>
                        <el-button v-if="closeBtn" class="btn-header" size="mini" type="text" @click="closeFn">
                            <i class="nucfont inuc-close"></i>
                        </el-button>
                    </div>
                </template>

                <slot></slot>
            </el-card>
        </el-main>
    </el-container>
</template>

<script>
/**
 * 用法说明：
 *  <sub-page title="情行页">
 *  如果传了title，页面会显示header和关闭按钮；如果不传title，则不显示header
 *
 * slot:
 *  header：整个头部部分
 *  prefix：标题前的部分
 */
    export default {
        // Note: 所有选项均为非必填
        props: {
            title: String,
            /**
             * 默认为false
             * 为true，则title固定，页面的滚动条限制在内容区域
             */
            fullPage: {
                type: Boolean,
                default: false,
            },
            // 朴素模式，该模式下无内置样式
            plain: {
                type: Boolean,
                default: false,
            },
            // title的对齐方式，left|center|right
            titleAlign: {
                type: String,
                default: 'center',
            },
            // 是否展示关闭按钮
            closeBtn: {
                type: Boolean,
                default: true,
            },
            // 关闭按钮的行为
            closeFn: {
                type: Function,
                default() {
                    return (() => {
                        history.go(-1);
                    })()
                }
            },
        },

        data() {
            return {}
        },

        mounted() {
            /**
             *  1、由于subPage是相对于.app-main-inner的绝对定位，
             *    所以在一级页面发生滚动的情况下进入subPage，需要给subPage的top设为页面已滚动的高度
             *  2、进入subPage后，为了不影响一级页面的滚动，需要将一级页面的overflowY设为hidden，离开subPage后再还原
             *  3、即使这样，在subPage中可能会有某些诡异的操作，导致一级页面滚动条发生了变化，从而影响subPage的定位
             *    所以监听一级页面滚动条，若产生变化，则将其还原到进入前的位置
             */
            setTimeout(() => {
                this.$mainPage = $('.app-main-inner')
                this.$subPage = $('.sub-page')

                let top = this.$mainPage.scrollTop()

                this.$subPage.css({
                    top: top
                });
                this.$mainPage.css({
                    overflowY: 'hidden'
                });

                this.$mainPage.on('scroll', (e) => {
                    this.$mainPage.scrollTop(top)
                    console.color('Subpage: 滚动条违规滚动 ', '滚动距离：'+this.$mainPage.scrollTop())
                })

            }, 100)
        },

        beforeDestroy() {
            this.$mainPage.css({
                overflow: 'auto'
            });

            this.$mainPage.off('scroll')
        },
    }
</script>

<style lang="scss">
    @import '../style/const.scss';

    $color-bg: rgb(238, 241, 246);

    .sub-page {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        right: 0;
        z-index: 9;
        background-color: $color-bg;
        @include scrollbar(#999);

        .el-card__header {
            position: relative;
            padding: 10px 20px;
        }

        .box-card > .el-card__header {
            font-size: 18px;
            background-color: #F2F4FD;
            box-shadow: 0 1px 4px #eee;
        }

        .el-card__body {
            padding-top: 30px;
        }

        .sub-page-header {
            @include clearfix;
            //line-height: 36px;
            text-align: center;
            color: #4d4d4d;
        }

        .btn-header {
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            width: 66px;
        }

        &.fullPage {
            .box-card {
                display: flex;
                flex-direction: column;
                height: 100%;

                > .el-card__body {
                    flex: 1;
                    overflow: auto;
                }
            }
        }

        &.plain {
            padding: 0;
            .box-card {
                background-color: $color-bg;
                border: none;
                box-shadow: none;
                .el-card__body {
                    padding: 0;
                }
            }
        }
    }

    @media screen and (max-width: 1367px) {
        .sub-page .el-card__body {
            padding: 15px;
        }
    }
</style>
